import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';

export interface IStudentSettingModule {
  currentPage: number;
}
@Module({ dynamic: true, store, name: 'studentSettingModule', namespaced: true })
class StudentSettingModule extends VuexModule implements IStudentSettingModule {
  currentPage: number = 1;

  @Mutation
  setCurrentPage(value: number) {
    this.currentPage = value;
  }
}

export const studentSettingModule = getModule(StudentSettingModule);
